<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-3" (click)="submit()">Zapisz i wyjdź</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a></app-navbar
>
<div class="container my-4">
	<form (submit)="submit()">
		<fieldset>
			<div class="form-floating mb-3">
				<input type="text" id="kind" class="form-control" name="kind" [(ngModel)]="data.kind" required />
				<label for="kind" class="form-label">Rodzaj<small class="ms-2 text-danger">* wymagane</small></label>
			</div>
		</fieldset>
	</form>
</div>
